export const LOCK_DURATION_SECONDS = 300; // 5 minutes

// BIN Modal States
export const CONFIRM_SPECIALTIES = 'CONFIRM_SPECIALTIES';
export const BOOK_FORM = 'BOOK_FORM';
export const LOCK_EXPIRED = 'LOCK_EXPIRED';
export const BOOK_SAVING = 'BOOK_SAVING';
export const BOOK_SUCCESS = 'BOOK_SUCCESS';
export const BOOK_FAILURE = 'BOOK_FAILURE';
export const BOOK_LOADING = 'BOOK_LOADING';
export const BOOK_LOCK_FAILURE = 'BOOK_LOCK_FAILURE';
export const CANT_CONFIRM_SPECIALTIES = 'CANT_CONFIRM_SPECIALTIES';
export const CAN_BOOK = 'CAN_BOOK';
export const TENDER_SUCCESS = 'TENDER_SUCCESS';
export const REQUIRED_TRAILER_NUMBER_CUSTOMERS = ['WALSACA01', 'RICBRMA1'];
export const ONLY_NUMBERS_TRAILER_NUMBER_CUSTOMERS = ['WALSACA01'];

export const CANT_CONFIRM_SPECIALTIES_TEXT = `Looks like you don't meet this load's specialty requirements. Try booking another load.`
